// extracted by mini-css-extract-plugin
export default {"height":"ModalRemoveUser_height__bTgig"};